import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import qapi from "views_shared/app/javascript/api";

const expertHubDemoImageUrl = RAILS_ASSET_URL("/expert-hub-demo.png");
const expertHubImageUrl = RAILS_ASSET_URL("/expert-hub-powered-by.png");

const requiredErrorText = "This field is required";

function ClaimThisPageModal({ isOpen = false, toggle = () => {}, companyId = null }) {
  const [form, setForm] = React.useState({});
  const [submitted, setSubmitted] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [serverResponse, setServerResponse] = React.useState({});

  const handleInputChange = (evt) => {
    const key = evt.target.name;
    const val = evt.target.value;

    setForm((previousForm) => ({ ...previousForm, [key]: val }));
  };

  const getFormErrors = () => {
    const errors = {};

    if (!form.name) {
      errors.name = requiredErrorText;
    }

    if (!form.email) {
      errors.email = requiredErrorText;
    }

    if (!form.phone) {
      errors.phone = requiredErrorText;
    }

    return errors;
  };

  const submit = (evt) => {
    if (evt) evt.preventDefault();

    const errors = getFormErrors();

    if (Object.keys(errors).length === 0) {
      setSubmitted(false);
      setIsLoading(true);
      setServerResponse({});

      // TODO: qapi.connectWithCompany
      qapi
        .connectWithCompany(companyId, form)
        .then(() => {
          setIsLoading(false);
          if (toggle) toggle();
        })
        .catch((xhr) => {
          setSubmitted(true);
          setIsLoading(false);

          const errorResponse = {};

          if (xhr && xhr.response && xhr.response.data) {
            const responseData = xhr.response.data;
            if (responseData.errors) {
              errorResponse.errors = responseData.errors;
            } else {
              errorResponse.message =
                responseData.message || responseData.error || "Something went wrong, please try again later.";
            }
          } else {
            errorResponse.message = "Something went wrong, please try again later.";
          }

          setServerResponse(errorResponse);
        });
    } else {
      setSubmitted(true);
    }
  };

  let errors = {};
  let errorMessage;

  if (submitted) {
    errors = getFormErrors();

    if (Object.keys(errors).length === 0) {
      errors = serverResponse.errors || {};
      errorMessage = serverResponse.message;
    }
  }

  const renderError = (field) => {
    let errorText = errors[field];

    if (!errorText) {
      return null;
    }

    if (Array.isArray(errorText)) {
      errorText = errorText.join(", ");
    }

    return <small className="form-text d-block text-danger">{errorText}</small>;
  };

  return (
    <Modal show={isOpen} onHide={toggle} dialogClassName="max-w-75" className="expert-hub-modal">
      <Modal.Body className="p-0">
        <div className="container-fluid pg-white">
          <div className="row">
            <div className="col-md-7 left-pane text-center text-white">
              <div className="d-flex h-100">
                <div className="align-self-center w-100 mt-3">
                  <ul className="list-inline text-uppercase mb-2 features-list">
                    <li className="list-inline-item border-end-white pe-2">Customize</li>
                    <li className="list-inline-item border-end-white pe-2">Feature</li>
                    <li className="list-inline-item ">Connect</li>
                  </ul>
                  <img src={expertHubDemoImageUrl} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
            <div className="col-md-5 right-pane pb-4">
              <div className="header text-end">
                <button type="button" className="btn font-size-22px mt-2 me-2 pb-0" aria-label="Close" onClick={toggle}>
                  <span aria-hidden="true" className="fa-solid fa-times" />
                </button>
                <div className="text-center">
                  <img src={expertHubImageUrl} alt="" className="img-fluid" />
                </div>
              </div>
              <div className="pt-3 pb-2 ps-5 pe-5 font-size-16px">
                Ready to level up your media strategy with real-time intelligence on reporter views & requests +
                improved SEO?
              </div>
              <div className="ps-5 pe-5">
                <form onSubmit={submit}>
                  <div className="form-group d-block">
                    <div className="text-danger">{errorMessage}</div>
                  </div>
                  <div className="form-group required">
                    <label htmlFor="name" className="form-label mb-0">
                      First Name and Last Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={form.name || ""}
                      onChange={handleInputChange}
                    />
                    {renderError("name")}
                  </div>
                  <div className="form-group">
                    <label htmlFor="job_title" className="form-label mb-0">
                      Job Title
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="job_title"
                      value={form.job_title || ""}
                      onChange={handleInputChange}
                    />
                    {renderError("job_title")}
                  </div>
                  <div className="form-group required">
                    <label htmlFor="email" className="form-label mb-0">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={form.email || ""}
                      onChange={handleInputChange}
                    />
                    {renderError("email")}
                  </div>
                  <div className="form-group required">
                    <label htmlFor="phone" className="form-label mb-0">
                      Phone Number
                    </label>
                    <input
                      type="phone"
                      className="form-control"
                      name="phone"
                      value={form.phone || ""}
                      onChange={handleInputChange}
                    />
                    {renderError("phone")}
                  </div>
                  <div className="form-group text-center d-grid">
                    <button type="submit" disabled={isLoading} className="btn mt-3 btn-primary">
                      Get Started
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

ClaimThisPageModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ClaimThisPageModal;
